import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  bad: '3 a 5 horas semanales planificando desde cero',
  good: '10 minutos por semana. El resto es estar en el piso con tus alumnas'
}, {
  bad: 'Siempre los mismos ejercicios → las alumnas se aburren',
  good: '60+ clases distintas → siempre hay algo nuevo para dar'
}, {
  bad: 'Alumnas que abandonan sin saber por qué',
  good: 'Sistema de progresión → retención visible desde el primer mes'
}, {
  bad: 'Sin progresión clara de aparato en aparato',
  good: '6 tomos con progresión anual → mejoran y se quedan'
}, {
  bad: 'Alumna con dificultad = pánico o improvisación',
  good: 'Protocolo técnico → actuás con confianza en cualquier situación'
}, {
  bad: 'Niveles mezclados = caos de clase',
  good: 'Variaciones por nivel → todas mejoran juntas en la misma clase'
}, {
  bad: 'Sin sistema de seguimiento claro',
  good: 'Fichas y planillas listas para registrar con criterio profesional'
}, {
  bad: 'Sin identidad profesional visible',
  good: 'Sistema que justifica cobrar lo que merecés'
}];
export function Comparison() {
  return <section className="py-10 md:py-20 bg-accent/30" data-id="element-49">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-50">
        <div className="text-center mb-6 md:mb-12" data-id="element-51">
          <h2 className="text-2xl md:text-5xl font-bold font-serif text-secondary-dark mb-2 md:mb-4" data-id="element-52">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl overflow-hidden border border-gray-200" data-id="element-53">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-54">
            {/* Bad Column */}
            <div className="bg-gray-50 p-4 md:p-10 border-b md:border-b-0 md:border-r border-gray-200" data-id="element-55">
              <h3 className="text-base md:text-xl font-bold text-gray-900 mb-4 md:mb-8 text-center flex items-center justify-center gap-1.5 md:gap-2" data-id="element-56">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500" data-id="element-57" />
                Sin Gimnasia Rítmica Resuelta
              </h3>
              <ul className="space-y-3 md:space-y-6" data-id="element-58">
                {comparisons.map((item, index) => <li key={index} className="flex items-start gap-2 md:gap-3" data-id="element-59">
                    <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-60" />
                    <span className="text-gray-600 font-medium text-xs md:text-base" data-id="element-61">
                      {item.bad}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Good Column */}
            <div className="bg-primary/5 p-4 md:p-10 relative" data-id="element-62">
              <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-63"></div>
              <h3 className="text-base md:text-xl font-bold text-primary mb-4 md:mb-8 text-center flex items-center justify-center gap-1.5 md:gap-2" data-id="element-64">
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-primary" data-id="element-65" />
                Con Gimnasia Rítmica Resuelta
              </h3>
              <ul className="space-y-3 md:space-y-6" data-id="element-66">
                {comparisons.map((item, index) => <li key={index} className="flex items-start gap-2 md:gap-3" data-id="element-67">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-68" />
                    <span className="text-gray-900 font-bold text-xs md:text-base" data-id="element-69">
                      {item.good}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}